import removeButton from './remove-button'
import pinned from './pinned'

export default {
    tabs: {
        related: 'Micro-trends',
        pinned: 'Selected micro-trends'
    },
    viewAll: 'Show all',
    add: {
        all: 'Add to work space, pin to macro-trend or pin to "{title}"',
        workspace: 'Add to work space',
        macrotrend: 'Pin to macro-trend or pin to "{title}"'
    },
    pinned,
    removeButton
}
